export default __webpack_public_path__ + "static/slider-3-8fe5f7502db0f45dcf54d07bc95a10dc.jpg";